import type { SVGProps } from "react";
const SvgBasketball01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M1.667 10.792c5.12.509 9.631-4.03 9.125-9.125M9.209 18.333c-.508-5.12 4.03-9.631 9.125-9.125"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.25}
      d="M14.167 16.667c0-5.983-4.85-10.834-10.834-10.834"
    />
  </svg>
);
export default SvgBasketball01;
